<template>
  <b-pagination-nav
    :number-of-pages="numberOfPages"
    :link-gen="linkGen"
    pills
    size="md"
    class="my-2"
    align="center"
    first-number
    last-number
    limit="15"
  />
</template>

<script>
export default {
  name: 'NavPagination',
  props: {
    numberOfPages: Number,
    path: String,
  },
  methods: {
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
  },
}
</script>
